export const dtCopy = {
  dt_s_page_title: "Procure por pacotes tipados",
  dt_s_title: "Pesquisa de tipo",
  dt_s_subtitle:
    "Encontre pacotes npm que tenham declarações de tipo, tanto agrupados quanto no Definitely Typed.",
  dt_s_match: "resultado",
  dt_s_matchs: "resultados",
  dt_s_match_exact: "Combinação exata",
  dt_s_popular_on_dt: "Popular no Definitely Typed",
  dt_s_downloads_short: "Downl.",
  dt_s_downloads_via: "Via",
  dt_s_module: "Módulo",
  dt_s_last_update: "Última atualização",
  dt_s_install: "Instalar",
  dt_s_no_results: "Nenhum resultado encontrado para",
  dt_s_no_results_try: "Tentar outra busca?",
  dt_s_copy: "copiar",
  dt_s_copied: "copiado",
}
